// extracted by mini-css-extract-plugin
export default {"banner-block":"vUby7","banner-block-load":"JAjs2"};